// Données structurées pour le référencement
export const agencyStructuredData = {
  "@context": "https://schema.org",
  "@type": "TravelAgency",
  "name": "Saldae Voyage",
  "image": "https://www.saldaevoyage.com/social/logo.png",
  "url": "https://www.saldaevoyage.com",
  "telephone": "+213 658 14 94 63",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Adresse de l'agence",
    "addressLocality": "Béjaïa",
    "postalCode": "06000",
    "addressCountry": "DZ"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "36.7525",
    "longitude": "5.0848"
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "09:00",
      "closes": "17:00"
    }
  ],
  "sameAs": [
    "https://www.facebook.com/saldaevoyage",
    "https://www.instagram.com/saldaevoyage"
  ],
  "priceRange": "$$"
};

export const servicesStructuredData = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "item": {
        "@type": "Service",
        "name": "Billetterie & Voyages organisés",
        "description": "Réservation de billets d'avion, organisation de voyages sur mesure, circuits touristiques et séjours tout compris.",
        "provider": {
          "@type": "TravelAgency",
          "name": "Saldae Voyage"
        }
      }
    },
    {
      "@type": "ListItem",
      "position": 2,
      "item": {
        "@type": "Service",
        "name": "Études à l'étranger",
        "description": "Accompagnement complet pour les études au Canada, France, Roumanie, Belgique et autres destinations.",
        "provider": {
          "@type": "TravelAgency",
          "name": "Saldae Voyage"
        }
      }
    },
    {
      "@type": "ListItem",
      "position": 3,
      "item": {
        "@type": "Service",
        "name": "Démarches touristiques & Visa",
        "description": "Assistance pour l'obtention de visas touristiques, d'affaires ou d'études pour tous pays.",
        "provider": {
          "@type": "TravelAgency",
          "name": "Saldae Voyage"
        }
      }
    },
    {
      "@type": "ListItem",
      "position": 4,
      "item": {
        "@type": "Service",
        "name": "Contrats de travail",
        "description": "Accompagnement pour l'obtention de contrats de travail au Canada, France, Allemagne et autres pays.",
        "provider": {
          "@type": "TravelAgency",
          "name": "Saldae Voyage"
        }
      }
    },
    {
      "@type": "ListItem",
      "position": 5,
      "item": {
        "@type": "Service",
        "name": "Immigration Canada",
        "description": "Services complets pour l'immigration au Canada: Entrée Express, Programme des candidats des provinces, regroupement familial et autres programmes.",
        "provider": {
          "@type": "TravelAgency",
          "name": "Saldae Voyage"
        }
      }
    }
  ]
}; 